import React from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { HtGoldBottomNavIcon, type NavIconId } from './HtGoldBottomNavIcons'

interface DockItem {
  id: NavIconId
  label: string
  to: string
}

interface HtGoldBottomNavProps {
  authenticated: boolean
  isLotteryEnabled?: boolean
  isCasinoEnabled?: boolean
  onBlockedAccess?: (service: 'lottery' | 'casino') => void
}

const ITEMS: DockItem[] = [
  { id: 'home', label: 'หน้าแรก', to: '/' },
  { id: 'bet', label: 'แทงหวย', to: '/lobby-huay/listall' },
  { id: 'control', label: 'ศูนย์ควบคุม', to: '/dashboard' },
  { id: 'games', label: 'เล่นเกมส์', to: '/lobby-casino' },
  { id: 'promo', label: 'โปรโมชั่น', to: '/promotion' },
]

function getActiveIndex(pathname: string): number {
  if (pathname.startsWith('/lobby-huay')) return 1
  if (
    pathname.startsWith('/dashboard') ||
    pathname.startsWith('/reward') ||
    pathname.startsWith('/history') ||
    pathname.startsWith('/member') ||
    pathname.startsWith('/howto') ||
    pathname.startsWith('/affiliate') ||
    pathname.startsWith('/live-tv') ||
    pathname.startsWith('/topup') ||
    pathname.startsWith('/withdraw')
  ) {
    return 2
  }
  if (pathname.startsWith('/lobby-casino')) return 3
  if (pathname.startsWith('/promotion') || pathname.startsWith('/cashback')) return 4
  if (pathname === '/' || pathname === '/login') return 0
  return 0
}

const HtGoldBottomNav: React.FC<HtGoldBottomNavProps> = ({
  authenticated,
  isLotteryEnabled = true,
  isCasinoEnabled = true,
  onBlockedAccess,
}) => {
  const { pathname } = useLocation()
  const navigate = useNavigate()
  const activeIndex = getActiveIndex(pathname)
  const activeItem = ITEMS[activeIndex]

  const handleClick = (item: DockItem, e: React.MouseEvent) => {
    if (item.id === 'home') return
    if (!authenticated) {
      e.preventDefault()
      navigate('/login')
      return
    }
    if (item.id === 'bet' && !isLotteryEnabled) {
      e.preventDefault()
      onBlockedAccess?.('lottery')
      return
    }
    if (item.id === 'games' && !isCasinoEnabled) {
      e.preventDefault()
      onBlockedAccess?.('casino')
    }
  }

  return (
    <div className="htg-dock-wrap">
      <nav className="htg-dock" aria-label="เมนูหลัก">
        <ul className="htg-dock__list">
          {ITEMS.map((item, index) => {
            const isActive = activeIndex === index
            const to = item.id === 'home' ? item.to : authenticated ? item.to : '/login'
            return (
              <li key={item.id} className={isActive ? 'is-active' : ''}>
                <Link to={to} className="htg-dock__link" onClick={(e) => handleClick(item, e)}>
                  {!isActive ? (
                    <span className="htg-dock__icon-slot">
                      <HtGoldBottomNavIcon id={item.id} />
                    </span>
                  ) : (
                    <span className="htg-dock__icon-slot htg-dock__icon-slot--spacer" aria-hidden />
                  )}
                  <span className="htg-dock__label">{item.label}</span>
                </Link>
              </li>
            )
          })}
        </ul>
        <div
          className="htg-dock__indicator"
          style={{ left: `${activeIndex * 20}%` }}
          aria-hidden
        >
          <div className="htg-dock__indicator-bubble">
            <HtGoldBottomNavIcon id={activeItem.id} raised />
          </div>
        </div>
      </nav>
    </div>
  )
}

export default HtGoldBottomNav
